import axios from 'axios';
import qs from 'querystring';
const instance = axios.create({
    baseURL: process.env.NODE_ENV == "development" ? 'http://10.20.40.244:8061' : 'https://api-seat.oo523.com/', //baseurl是axios的前置请求路径
    timeout: 12000 //12S超时
})
instance.interceptors.request.use(request => {
    if(request.data && request.data.isLogin || request.data && request.data.constructor == FormData){
        if(request.data.constructor == FormData){
            request.headers['Authorization'] = 'Bearer '+request.data.get('token');
        }else{
            request.headers['Authorization'] = 'Bearer '+request.data.token;
        }
    }
    if(request.data && request.data.isform){
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded';

        request.data = qs.stringify(request.data)

    }
    return request;
}, function (error) {
    return Promise.reject(error);
})

/*
  拦截响应
*/
instance.interceptors.response.use(res => {
    return res
}, (error) => {
    return Promise.reject(error);
})

export default function (method, url, data = null) {
    method = method.toLowerCase();
    switch (method) {
        case "post":
            return instance.post(url, data);
            break;
        case "get":
            return instance.get(url, { params: data });
            break;
        case "delete":
            return instance.delete(url, { params: data })
            break;
        case "put":
            return instance.put(url, data)
            break;
        default:
            console.error("未知的请求方式！" + method);
            return false;
            break;
    };
};